// 畅联直连
export const changLianConnectionRouter = [
  {
    path: '/service/changLianConnection/product',
    name: 'ChangLianProductList',
    component: () => import('@/views/service/serviceProvider/changLianConnection/ChangLianProductList'),
    meta: {
      title: '同步产品',
      keepAlive: false
    }
  },
  {
    path: '/service/changLianConnection/order',
    name: 'ChangLianOrderList',
    component: () => import('@/views/service/serviceProvider/changLianConnection/ChangLianOrderList'),
    meta: {
      title: '订单列表',
      keepAlive: false
    }
  },
  {
    path: '/service/changLianConnection/apiConfigure',
    name: 'ChangLianApiConfigure',
    component: () => import('@/views/service/serviceProvider/changLianConnection/ChangLianApiConfigure'),
    meta: {
      title: 'API配置',
      keepAlive: false
    }
  }
]